import { render } from "./responsible_gaming_view.vue?vue&type=template&id=e301551e"
import script from "./responsible_gaming_view.vue?vue&type=script&lang=js"
export * from "./responsible_gaming_view.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__